{
  "SESSION_LIMIT": {
    "TITLE": "Limite de sessão ativo atingido",
    "DESCRIPTION": "Você atingiu seu limite de sessões ativas. Por favor, encerre uma sessão antes de fazer o login.",
    "END": "Término",
    "END_ALL": "Encerrar todas as sessões",
    "LOG_IN": "Efetuar Login",
    "CANCEL": "Voltar ao login",
    "UNKNOWN_DEVICE": "Dispositivo desconhecido",
    "STARTED": "Iniciado"
  }
}
